import {
  textDefaultProps,
  imageDefaultProps,
  shapeDefaultProps,
  TextComponentProps,
  ImageComponentProps,
  ShapeComponentProps
} from '@smilekite/lego-bricks'

export type BrickComponents = 'l-text' | 'l-image' | 'l-shape'
export type BrickComponentProps = TextComponentProps | ImageComponentProps | ShapeComponentProps

export enum TemplateType {
  TEXT = 'text',
  IMAGE = 'image',
  SHAPE = 'shape'
}

const textTemplates = [
  {
    text: '大标题',
    fontSize: '30px',
    fontWeight: 'bold',
    tag: 'h1',
    width: '100px'
  },
  {
    text: '楷体副标题',
    fontSize: '20px',
    fontWeight: 'bold',
    tag: 'h2',
    width: '100px',
    fontFamily: 'KaiTi, STKaiti'
  },
  {
    text: '宋体正文内容',
    fontSize: '14px',
    tag: 'p',
    width: '100px',
    fontFamily: 'SimSun, STSong'
  },
  {
    text: 'Arial Style',
    fontSize: '14px',
    tag: 'p',
    width: '100px',
    fontFamily: 'Arial, sans-serif'
  },
  {
    text: 'Courier New',
    fontSize: '14px',
    tag: 'p',
    width: '100px',
    fontFamily: '"Courier New", monospace'
  },
  {
    text: '正文内容',
    tag: 'p',
    width: '100px'
  },
  {
    text: '链接内容',
    color: '#1890ff',
    textDecoration: 'underline',
    tag: 'p',
    width: '100px'
  },
  {
    text: '按钮内容',
    color: '#ffffff',
    backgroundColor: '#1890ff',
    borderWidth: '1px',
    borderColor: '#1890ff',
    borderStyle: 'solid',
    borderRadius: '2px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '5px',
    paddingBottom: '5px',
    width: '100px',
    tag: 'button',
    textAlign: 'center',
    position: 'absolute'
  }
]
const shapeTemplates = [
  {
    width: '100px',
    height: '50px',
    backgroundColor: '#efefef',
    borderStyle: 'solid',
    borderColor: '#ccc',
    borderWidth: '1px'
  },
  {
    width: '100px',
    height: '50px',
    borderRadius: '50px',
    backgroundColor: '#36CFC9'
  },
  {
    width: '100px',
    height: '100px',
    backgroundColor: '#40A9FF',
    borderRadius: '100%'
  },
  {
    width: '0px',
    height: '0px',
    borderStyle: 'solid',
    borderWidth: '50px',
    borderColor: '#1890ff transparent transparent transparent'
  },
  {
    width: '0px',
    height: '0px',
    borderStyle: 'solid',
    borderWidth: '50px',
    borderColor: 'transparent transparent transparent #52c41a'
  },
  {
    width: '0px',
    height: '0px',
    borderStyle: 'solid',
    borderWidth: '50px',
    borderColor: 'transparent #9254DE transparent transparent'
  },

  {
    width: '0px',
    height: '0px',
    borderStyle: 'solid',
    borderWidth: '50px',
    borderColor: 'transparent transparent #faad14 transparent'
  }
]
const imageTemplates = [
  {
    width: '100px',
    height: '150px',
    src: 'https://file.smilekite.site/lego/badge1.png'
  },
  {
    width: '100px',
    height: '150px',
    src: 'https://file.smilekite.site/lego/badge2.png'
  },
  {
    width: '100px',
    height: '64px',
    src: 'https://file.smilekite.site/lego/text-1.png'
  },
  {
    width: '100px',
    height: '64px',
    src: 'https://file.smilekite.site/lego/text2-2.png'
  },
  {
    width: '100px',
    height: '100px',
    src: 'https://file.smilekite.site/lego/bag-1.png'
  },
  {
    width: '100px',
    height: '100px',
    src: 'https://file.smilekite.site/lego/money.png'
  }
]
const defaultTextTemplates = textTemplates.map(template => ({ ...textDefaultProps, ...template }))
const defaultShapeTemplates = shapeTemplates.map(template => ({ ...shapeDefaultProps, ...template }))
const defaultImageTemplates = imageTemplates.map(template => ({ ...imageDefaultProps, ...template }))

export const brickTemplates = {
  [TemplateType.TEXT]: defaultTextTemplates,
  [TemplateType.SHAPE]: defaultShapeTemplates,
  [TemplateType.IMAGE]: defaultImageTemplates
}
